import * as React from "react";
const SvgSendOutline = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#262626", d: "M2.434 2a.45.45 0 0 0-.4.62L4.213 8l-2.18 5.38a.45.45 0 0 0 .617.572l11.1-5.55a.45.45 0 0 0 0-.805l-11.1-5.55A.45.45 0 0 0 2.434 2m.881 1.385L12.545 8l-9.23 4.614L5.004 8.45H9.05a.45.45 0 1 0 0-.9H5.004z" }));
export default SvgSendOutline;
